import { createSelector } from 'reselect';

import { rootStateBranchSelector } from 'shared/utils/rootStateBranchSelector';

export const getCustomSelector = rootStateBranchSelector('custom');

export const coworkingIdSelector = createSelector(getCustomSelector, custom => custom.coworkingId);
export const coworkingIdAsNumberSelector = createSelector(coworkingIdSelector, coworkingId => Number(coworkingId));
export const offerIdIdSelector = createSelector(getCustomSelector, custom => custom?.offerId ?? null);
export const offerIdAsNumberSelector = createSelector(offerIdIdSelector, offerId =>
  typeof offerId === 'string' ? Number(offerId) : (offerId ?? null),
);
